module.exports = __webpack_public_path__ + "media/unipod/people_experience_1-98edef95.jpg";